import { IAccount } from "@modeso/types__aumico-lib-annualreport-be";
import { IDataGridDisplayAccount } from "../interfaces/data-grid-display-accounts.interface";

export class DuplicateAccountHelper {

    static markDuplicateAccounts(accounts: IAccount[]): IDataGridDisplayAccount[] {
        const accountNumberCount: { [accountNumber: string]: number } = {};

        // Count occurrences of each account number
        accounts.forEach(account => {
            const isShareholderAccount = account.shareholder != null && account.shareholder !== '';
            const identifier = isShareholderAccount ? account.accountNumber + "__" + account.shareholder : account.accountNumber;
            if (identifier) {
                accountNumberCount[identifier] = (accountNumberCount[identifier] || 0) + 1;
            }
        });

        // Mark accounts with duplicate account numbers
        return accounts.map(account => {
            const isShareholderAccount = account.shareholder != null && account.shareholder !== '';
            const identifier = isShareholderAccount ? account.accountNumber + "__" + account.shareholder : account.accountNumber;
            const isDuplicate = identifier ? accountNumberCount[identifier] > 1 : false;

            // Determine if this is the last account in a series of duplicates
            let isLast = false;
            if (isDuplicate && identifier) {
                const duplicateAccounts = accounts.filter(acc => {
                    const isShareholderAccount = acc.shareholder != null && acc.shareholder !== '';
                    const accIdentifier = isShareholderAccount ? acc.accountNumber + "__" + acc.shareholder : acc.accountNumber;
                    return accIdentifier === identifier;
                });
                const lastDuplicateAccount = duplicateAccounts[duplicateAccounts.length - 1];
                isLast = lastDuplicateAccount === account;
            }

            const displayName = isShareholderAccount
                ? `${account.name} - ${account.shareholder}`
                : account.name || '';
            return {
                ...account,
                displayName: displayName,
                isDuplicateAccountNumber: isDuplicate,
                isSummarized: account.isSummarized || false,
                isEndOfDuplicateAccounts: isLast || false,
            } as IDataGridDisplayAccount;
        });
    }


}